import React, { useReducer } from 'react';

import IdentityHelper from '../../utilities/IdentityHelper';

import AuthContext from './authContext';
import AuthReducer from './authReducer';
import { GET_AUTHENTICATION_DETAILS, OKTA_LOGIN_PAGE, SET_AUTHENTICATION_DETAILS } from './types';

const AuthState = (props) => {
  const initialState = {
    authenticated: false,
    authenticatedLoading: false,
  };

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  // Get Client Details
  const getAuthenticationDetails = (data) => {
    dispatch({ type: GET_AUTHENTICATION_DETAILS, payload: data });
  };

  const setAuthenticationDetails = (data) => {
    dispatch({ type: SET_AUTHENTICATION_DETAILS, payload: data });
  };

  const getOktaAccessToken = async () => {
    const isDev = true;

    //* For testing, the Okta token can be found in the REQUEST call to the
    //* API callCentreCreateQuote - Not in the API response.
    if (import.meta.env.MODE === 'localdev' && isDev === true) {
      return {
        accessToken: import.meta.env.VITE_TEMP_ACCESS_CODE,
      };
    }

    try {
      let oktaClient = IdentityHelper.getOktaAuthClient();
      let oktaAccessToken = await oktaClient.tokenManager.get('accessToken');
      if (oktaAccessToken && !oktaClient.tokenManager.hasExpired(oktaAccessToken)) {
        return oktaAccessToken;
      } else {
        const { status, tokens } = await oktaClient.idx.authenticate();
        if (tokens && status === 'SUCCESS') {
          oktaClient.tokenManager.setTokens(tokens);
          return tokens;
        } else {
          // Okta Session is expired, redirect to Okta page for login
          window.location.href = OKTA_LOGIN_PAGE;
        }
      }
    } catch (error) {
      IdentityHelper.clearStorage();
      window.location.href = OKTA_LOGIN_PAGE;
      console.error(error);
      throw error; // throw the error back to the calling method
    }
  };

  return (
    <AuthContext.Provider
      value={{
        authenticated: state.authenticated,
        authenticatedLoading: state.authenticatedLoading,
        getAuthenticationDetails,
        setAuthenticationDetails,
        getOktaAccessToken,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
